@if (hasAiPermission() && hasAiAssistantEnabled()) {
  @if ('lg' | up) {
    <div
      class="fixed inset-x-0 bottom-0 z-40 flex items-center justify-between px-4 py-1 bg-background-container-primary min-h-[32px] drop-shadow-foreground-primary-100-shadow-30"
    >
      <div class="flex items-center gap-4 text-xs">
        <span class="text-foreground-primary-60">{{ 'ai-assistant.beta-access' | translate }}</span>
        <a href="#" class="text-action-secondary dark:text-action-secondary-text" (click)="$event.preventDefault()">{{
          'ai-assistant.feedback' | translate
        }}</a>
      </div>

      <div class="flex items-center gap-2">
        @if (!production) {
          @for (item of recentConversations(); track item.id) {
            <button
              type="button"
              class="max-w-[180px] py-1 px-2 text-xs font-medium overflow-hidden text-ellipsis whitespace-nowrap transition-colors rounded-radius-tertiary text-foreground-primary-80"
              [ngClass]="{
                '[&&]:bg-action-secondary-18 dark:[&&]:bg-background-main [&&]:text-action-secondary dark:[&&]:text-action-secondary-text':
                  item.isActive,
              }"
              (click)="onRecentConversationClick(item.id)"
            >
              {{ item.title }}
            </button>
          }
        }

        <button
          type="button"
          class="flex items-center gap-2 text-xs font-medium text-action-secondary dark:text-foreground-primary-100"
          (click)="onAskAiClick()"
        >
          <span>{{ 'ai-assistant.ask-optimo-ai' | translate }}</span>
          <svg-icon key="ai-24" size="24" class="text-action-secondary dark:text-action-secondary-text" />
        </button>
      </div>
    </div>
  } @else {
    <button
      type="button"
      class="fixed bottom-4 right-4 z-40 flex items-center justify-center text-action-secondary dark:text-action-secondary-text rounded-full bg-background-container-primary drop-shadow-foreground-primary-100-shadow-30 p-2"
      [attr.aria-label]="'ai-assistant.ask-optimo-ai' | translate"
      (click)="onAskAiClick()"
    >
      <svg-icon key="ai-24" size="32" />
    </button>
  }
}
